import cartItemsHtml from './cartitems.component.html';
import './cartitems.component.scss';

class CartItemsController {
    constructor($scope, $sce, CartService, ModalService) {
        'ngInject';
        this.service = CartService;
        this.ModalService = ModalService;
        this.$scope = $scope;
        this.$sce = $sce;

        this.$scope.keyLength = function (obj) {
            return Object.keys(obj).length;
        }
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load().then(() => {
                if (!this.step && !sessionStorage.getItem('fbq_initiate_checkout_sent')) {
                    this.service.fbqBeginCheckout();

                    sessionStorage.setItem('fbq_initiate_checkout_sent', '1');
                }

                const WINTER_HOLIDAY_MODAL_WINDOW = {
                    from: new Date(2025, 11, 20, 0, 0, 0),
                    to: new Date(2026, 0, 12, 23, 59, 59),
                };

                const now = new Date();

                if (now >= WINTER_HOLIDAY_MODAL_WINDOW.from && now <= WINTER_HOLIDAY_MODAL_WINDOW.to) {
                    const modalRef = this.ModalService.add(
                        null,
                        `<cart-winter-holiday-modal></cart-winter-holiday-modal>`,
                        null,
                        false,
                        'cart-winter-holiday-modal'
                    );

                    modalRef.open();
                }
            });
        }
    }

    decreaseQuantity(cartItem) {
        if (parseInt(cartItem.quantity) < 1) return;

        this.changeQuantity(cartItem, parseInt(cartItem.quantity) - 1);
    }

    increaseQuantity(cartItem) {
        this.changeQuantity(cartItem, parseInt(cartItem.quantity) + 1);
    }

    changeQuantity(cartItem, quantity) {
        if (quantity < 0) return;

        cartItem.quantity = parseInt(quantity);

        if (quantity == 0) {
            this.removeItem(cartItem);
            return;
        }

        this.service.changeQuantity(cartItem);
    }

    removeItem(cartItem) {
        this.service.removeItem(cartItem);
    }
}

let cartItemsComponent = {
    bindings: {},
    template: cartItemsHtml,
    controller: CartItemsController
}

export default cartItemsComponent;
